import {NgModule} from '@angular/core';
import {ProviderServiceModule} from './service/providerService.module';
import {ProviderCommonModule} from './common/providerCommon.module';

@NgModule({
    imports: [
        ProviderServiceModule,
        ProviderCommonModule,
    ],
})
export class ProviderModule {
}
